// App.jsx
import React, { useEffect } from "react";
import {
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { CurrencyProvider } from "./pages/CurrencyContext";
import Sidebar from "./components/Sidebar/Sidebar";
import Home from "./components/HomePage/HomePage";
// import Employee from "./components/Employee/Employee";
import Header from "./components/Header/Header";
import AddCurrency from "./pages/Currency/Currency";
import CurrencyList from "./pages/Currency/CurrencyList";
import EditCurrency from "./pages/Currency/EditCurrency";
import AddCountry from "./pages/Country/Country";
import CountryList from "./pages/Country/CountryList";
import EditCountry from "./pages/Country/EditCountry";
import AddBusinessType from "./pages/Businesstype/Businesstype";
import BusinessTypeList from "./pages/Businesstype/BusinessTypeList";
import EditBusinessType from "./pages/Businesstype/EditBusinessType";
import ProductCategoryList from "./pages/ProductCategory/ProductCategoryList";
import UnitsOfMeasureList from "./pages/UnitsOfMeasure/UnitsOfMeasureList";
import ProductsList from "./pages/Products/ProductsList";
import AddProductUomConversions from "./pages/ProductUomConversions/ProductUomConversions";
import ProductUomConversionsList from "./pages/ProductUomConversions/ProductUomConversionsList";
import EditProductUomConversions from "./pages/ProductUomConversions/EditProductUomConversions";
import ProductBarcodeList from "./pages/ProductBarcode/ProductBarcodesList";
import AddWareHouses from "./pages/WareHouses/WareHouses";
import WareHousesList from "./pages/WareHouses/WareHousesList";
import EditWareHouses from "./pages/WareHouses/EditWareHouses";
import AddSuppliers from "./pages/Suppliers/Suppliers";
import SuppliersList from "./pages/Suppliers/SuppliersList";
import EditSuppliers from "./pages/Suppliers/EditSuppliers";

// import AddAccounts from "./pages/Accounts/Accounts";
// // import AccountsList from "./pages/Accounts/AccountsList";
// import AccountTransactionsView from "./pages/Accounts/AccountTransactionsView";
// import EditAccounts from "./pages/Accounts/EditAccounts";
import Discounts from "./pages/Discounts/Discounts";
import Taxes from "./pages/Taxes/Taxes";
import AddPaymentType from "./pages/PaymentType/PaymentType";
import PaymentTypeList from "./pages/PaymentType/PaymentTypeList";
import EditPaymentType from "./pages/PaymentType/EditPaymentType";
import AccountingType from "./pages/AccountingTypes/AccountingType";
import AccountingTypeList from "./pages/AccountingTypes/AccountingTypeList";
import EditAccountingType from "./pages/AccountingTypes/EditAccountingType";
import ChartOfAccounts from "./pages/ChartOfAccounts/ChartOfAccounts";
import AccountLedger from "./pages/ChartOfAccounts/AccountLedger";
import BeginningBalances from "./pages/BeginningBalances/BeginningBalances";
import AddExpenses from "./pages/Expenses/Expenses";
import ExpensesList from "./pages/Expenses/ExpensesList";
import EditExpenses from "./pages/Expenses/EditExpenses";
import InventoryStockList from "./pages/InventoryStock/InventoryStockList";
import PurchaseInventoryTransactionList from "./pages/PurchaseTransaction/PurchaseInventoryTransactionList";
import AddOpeningBalance from "./pages/InventoryTransaction/OpeningBalance";
import OpeningBalanceList from "./pages/InventoryTransaction/OpeningBalanceList";
import AddStockAdjustments from "./pages/StockAdjustments/StockAdjustments";
import StockAdjustmentsList from "./pages/StockAdjustments/StockAdjustmentsList";
import EditStockAdjustments from "./pages/StockAdjustments/EditStockAdjustments";
import AddStockTransfer from "./pages/StockTransfer/StockTransfer";
import StockTransferList from "./pages/StockTransfer/StockTransferList";
import EditStockTransfer from "./pages/StockTransfer/EditStockTransfer";

import AddSalesOrder from "./pages/SalesOrder/SalesOrder";
import SalesOrdersList from "./pages/SalesOrder/SalesOrdersList";
import ConvertOrderToInvoice from "./pages/SalesOrder/ConvertOrderToInvoice";
import EditSalesOrder from "./pages/SalesOrder/EditSalesOrder";
import SalesInventoryTransactionList from "./pages/SalesTransaction/SalesInventoryTransactionList";
import AddPurchaseOrder from "./pages/PurchaseOrder/PurchaseOrder";
import PurchaseOrdersList from "./pages/PurchaseOrder/PurchaseOrderList";
import ConvertOrderToGRN from "./pages/PurchaseOrder/ConvertOrderToGRN";
import EditPurchaseOrder from "./pages/PurchaseOrder/EditPurchaseOrder";
import AddTransactionType from "./pages/TransactionType/TransactionType";
import TransactionTypeList from "./pages/TransactionType/TransactionTypeList";
import EditTransactionType from "./pages/TransactionType/EditTransactionType";
import AddPurchaseTransaction from "./pages/PurchaseTransaction/PurchaseTransaction";
import PurchaseTransactionList from "./pages/PurchaseTransaction/PurchaseTransactionList";
import EditPurchaseTransaction from "./pages/PurchaseTransaction/EditPurchaseTransaction";
import PurchaseInvoiceList from "./pages/PurchaseTransaction/PurchaseInvoiceList";
import PurchaseInvoiceView from "./pages/PurchaseTransaction/PurchaseInvoiceView";
import AddSalesTransaction from "./pages/SalesTransaction/SalesTransaction";
import SalesTransactionList from "./pages/SalesTransaction/SalesTransactionList";
import EditSalesTransaction from "./pages/SalesTransaction/EditSalesTransaction";
import SalesInvoiceList from "./pages/SalesTransaction/SalesInvoiceList";
import SalesInvoiceView from "./pages/SalesTransaction/SalesInvoiceView";
import AddSupplierPayment from "./pages/SupplierPayment/SupplierPayment";
import SupplierPaymentList from "./pages/SupplierPayment/SupplierPaymentList";
import AddCustomerPayment from "./pages/CustomerPayment/CustomerPayment";
import CustomerPaymentList from "./pages/CustomerPayment/CustomerPaymentList";
import Transferform from "./pages/Transferform/Transferform";
import TransferformList from "./pages/Transferform/TransferformList";
import EditTransferform from "./pages/Transferform/EditTransferform";
import AddCompany from "./pages/Company/Company";
import CompanyList from "./pages/Company/CompanyList";
import ViewCompany from './pages/Company/ViewCompany';
import AddUserForm from './pages/Company/AddUserForm';
import CompanyUsersList from './pages/Company/CompanyUsersList'; // NEW: user list component
import EditCompany from "./pages/Company/EditCompany";
import AddCustomer from "./pages/Customer/Customer";
import CustomerList from "./pages/Customer/CustomerList";
import EditCustomer from "./pages/Customer/EditCustomer";
import "./App.css";
import AddRole from "./pages/Role/Role";
import RoleList from "./pages/Role/RoleList";
import EditRole from "./pages/Role/EditRole";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute.jsx/ProtectedRoute";
import Unauthorized from "./pages/Unauthorized";
import Settings from "./pages/Settings/Settings";
import CompanySettings from "./pages/Settings/CompanySettings";
import Subscriptions from "./pages/Subscriptions/Subscriptions";
import MySubscription from "./pages/MySubscription/MySubscription";
// import UpdateUser from "./pages/users/UpdateUser";
import Register from "./pages/users/Register";
import Login from "./pages/users/Login";
// import EmployeeLists from "./pages/Settings/Employeelists";
import AddInstitution from "./pages/Institution/Institution";
import InstitutionList from "./pages/Institution/InstitutionList";
import EditInstitution from "./pages/Institution/EditInstitution";
import AuditLogsList from "./pages/AuditLog/AuditLogsList";
import AuditLogs from "./pages/AuditLog/AuditLogs";
// All Reports
import Inventoryvaluation from "./pages/AllReport/Inventoryvaluation";
import Stocksummery from "./pages/AllReport/Stocksummery";
import Lowstockreport from "./pages/AllReport/Lowstockreport";
import Purchasereport from "./pages/AllReport/Purchasereport";
import Salesreport from "./pages/AllReport/Salesreport";
import Customerreport from "./pages/AllReport/Customerreport";
import Supplierreport from "./pages/AllReport/Supplierreport";
import Customerdetailreport from "./pages/AllReport/Customerdetailreport";
import Supplierdetailreport from "./pages/AllReport/Supplierdetailreport";
import Dailysummery from "./pages/Dailyreport/Dailysummery";
import Expensesummery from "./pages/AllReport/Expensesummery";
import TrialBalance from "./pages/AllReport/TrialBalance";
import BalanceSheet from "./pages/AllReport/BalanceSheet";
import IncomeStatemen from "./pages/AllReport/IncomeStatement";
import ManualJournalEntryForm from "./pages/accounting/ManualJournalEntryForm";
import IncomeStatement from "./pages/AllReport/IncomeStatement";
// Loading spinner
function LoadingSpinner() {
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p>Loading...</p>
    </div>
  );
}

// AppContent
function AppContent() {
  const { currentUser, loading, userType, company } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const redirectToMySubscription = (subscriptionData = {}) => {
      // Only company users should be redirected.
      if (userType !== "company") {
        return;
      }

      localStorage.setItem(
        "subscriptionBlocked",
        JSON.stringify(subscriptionData),
      );

      if (location.pathname !== "/MySubscription") {
        navigate("/MySubscription", {
          replace: true,
        });
      }
    };

    const handleSubscriptionExpired = (event) => {
      redirectToMySubscription(event.detail || {});
    };

    window.addEventListener(
      "subscription-expired",
      handleSubscriptionExpired,
    );

    // Preserve the blocked state after a browser refresh.
    const storedBlockedSubscription = localStorage.getItem(
      "subscriptionBlocked",
    );

    if (
      currentUser &&
      userType === "company" &&
      storedBlockedSubscription &&
      location.pathname !== "/MySubscription"
    ) {
      try {
        redirectToMySubscription(
          JSON.parse(storedBlockedSubscription),
        );
      } catch {
        redirectToMySubscription({});
      }
    }

    return () => {
      window.removeEventListener(
        "subscription-expired",
        handleSubscriptionExpired,
      );
    };
  }, [
    currentUser,
    userType,
    navigate,
    location.pathname,
  ]);

  if (loading) {
    return <LoadingSpinner />;
  }

  // User not logged in
  if (!currentUser) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  // User logged in – wrap everything with CurrencyProvider
  return (
    <CurrencyProvider company={company}>
      <div className="app-container">
        <Sidebar />
        <main className="main-content">
          <Header />
          <div className="content-wrapper">
            <Routes>
              {/* Dashboard */}
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Home />
                  </ProtectedRoute>
                }
              />

              {/* Role management */}
              <Route
                path="/ViewRole"
                element={
                  <ProtectedRoute requiredRole={["developer"]}>
                    <RoleList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/AddRole"
                element={
                  <ProtectedRoute requiredRole={["developer"]}>
                    <AddRole />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/role/edit/:id"
                element={
                  <ProtectedRoute requiredRole={["developer"]}>
                    <EditRole />
                  </ProtectedRoute>
                }
              />

              {/* Currency */}
              <Route
                path="/AddCurrency"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <AddCurrency />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewCurrency"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <CurrencyList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/currency/edit/:id"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <EditCurrency />
                  </ProtectedRoute>
                }
              />

              {/* Country */}
              <Route
                path="/AddCountry"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <AddCountry />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewCountry"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <CountryList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/country/edit/:id"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <EditCountry />
                  </ProtectedRoute>
                }
              />

              {/* Business Type */}
              <Route
                path="/AddBusinessType"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <AddBusinessType />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewBusinessType"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <BusinessTypeList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/businesstype/edit/:id"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <EditBusinessType />
                  </ProtectedRoute>
                }
              />

              {/* Product Category */}
              <Route
                path="/ViewProductCategory"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <ProductCategoryList />
                  </ProtectedRoute>
                }
              />
              {/* Units of Measure */}
              <Route
                path="/ViewUnitsOfMeasure"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <UnitsOfMeasureList />
                  </ProtectedRoute>
                }
              />

              {/* Products */}

              <Route
                path="/ViewProducts"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "sales", "user"]}>
                    <ProductsList />
                  </ProtectedRoute>
                }
              />


              {/* Product UOM Conversions */}
              <Route
                path="/AddProductUomConversions"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <AddProductUomConversions />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewProductUomConversions"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <ProductUomConversionsList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/puomc/edit/:id"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <EditProductUomConversions />
                  </ProtectedRoute>
                }
              />


              <Route
                path="/ViewProductBarcodes"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <ProductBarcodeList />
                  </ProtectedRoute>
                }
              />


              {/* Warehouses */}
              <Route
                path="/AddWareHouses"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <AddWareHouses />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewWareHouses"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <WareHousesList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/warehouse/edit/:id"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <EditWareHouses />
                  </ProtectedRoute>
                }
              />

              {/* Suppliers */}
              <Route
                path="/AddSuppliers"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "purchase", "user"]}>
                    <AddSuppliers />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewSuppliers"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "purchase", "user"]}>
                    <SuppliersList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/supplier/edit/:id"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    < EditSuppliers />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/Discounts"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <Discounts />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/Taxes"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <Taxes />
                  </ProtectedRoute>
                }
              />

              {/* Payment Type */}
              <Route
                path="/AddPaymentType"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <AddPaymentType />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewPaymentType"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <PaymentTypeList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/paymenttype/edit/:id"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <EditPaymentType />
                  </ProtectedRoute>
                }
              />
              {/* Accounting Types */}
              <Route
                path="/AddAccountingType"
                element={
                  <ProtectedRoute
                    requiredRole={["developer", "admin"]}
                  >
                    <AccountingType />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/ViewAccountingTypes"
                element={
                  <ProtectedRoute
                    requiredRole={["developer", "admin"]}
                  >
                    <AccountingTypeList />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/accounting-types/edit/:id"
                element={
                  <ProtectedRoute
                    requiredRole={["developer", "admin"]}
                  >
                    <EditAccountingType />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/ViewAccounts"
                element={
                  <ProtectedRoute
                    requiredRole={["developer", "admin"]}
                  >
                    <ChartOfAccounts />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/account-ledger/:id"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <AccountLedger />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/BeginningBalances"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <BeginningBalances />
                  </ProtectedRoute>
                }
              />

              {/* Expenses */}
              <Route
                path="/AddExpenses"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "cashier", "user"]}>
                    <AddExpenses />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewExpenses"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "cashier", "user"]}>
                    <ExpensesList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/expense/edit/:id"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <EditExpenses />
                  </ProtectedRoute>
                }
              />

              {/* Inventory Stock */}
              <Route
                path="/ViewInventoryStock"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <InventoryStockList />
                  </ProtectedRoute>
                }
              />

              {/* Purchase Inventory Transaction */}
              <Route
                path="/ViewPurchaseInventoryTransaction"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "purchase", "user"]}>
                    <PurchaseInventoryTransactionList />
                  </ProtectedRoute>
                }
              />

              {/* Sales Inventory Transaction */}
              <Route
                path="/ViewSalesInventoryTransaction"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "sales"]}>
                    <SalesInventoryTransactionList />
                  </ProtectedRoute>
                }
              />

              {/* Opening Balance */}
              <Route
                path="/AddOpeningBalance"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <AddOpeningBalance />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/ViewOpeningBalance"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <OpeningBalanceList />
                  </ProtectedRoute>
                }
              />


              {/* Stock Adjustments */}
              <Route
                path="/AddStockAdjustments"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "sales", "purchase", "user"]}>
                    <AddStockAdjustments />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewStockAdjustments"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "sales", "purchase", "user"]}>
                    <StockAdjustmentsList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/stockadjustments/edit/:id"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <EditStockAdjustments />
                  </ProtectedRoute>
                }
              />

              {/* Sales Order */}
              <Route
                path="/AddSalesOrder"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "sales", "user"]}>
                    <AddSalesOrder />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewSalesOrder"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "sales", "user"]}>
                    <SalesOrdersList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/salesorders/:id/convert"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "sales"]}>
                    <ConvertOrderToInvoice />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/salesorders/edit/:id"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin","user"]}>
                    <EditSalesOrder />
                  </ProtectedRoute>
                }
              />

              {/* Purchase Order */}
              <Route
                path="/AddPurchaseOrder"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "purchase", "user"]}>
                    <AddPurchaseOrder />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewPurchaseOrder"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "purchase", "user"]}>
                    <PurchaseOrdersList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/purchaseorders/:id/convert"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "purchase"]}>
                    <ConvertOrderToGRN />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/purchaseorders/edit/:id"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <EditPurchaseOrder />
                  </ProtectedRoute>
                }
              />

              {/* Stock Transfer */}
              <Route
                path="/AddStockTransfer"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "purchase", "user"]}>
                    <AddStockTransfer />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewStockTransfer"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "purchase", "user"]}>
                    <StockTransferList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/stocktransfers/edit/:id"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <EditStockTransfer />
                  </ProtectedRoute>
                }
              />

              {/* Transaction Type */}
              <Route
                path="/AddTransactionType"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <AddTransactionType />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewTransactionType"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <TransactionTypeList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/transactiontype/edit/:id"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <EditTransactionType />
                  </ProtectedRoute>
                }
              />

              {/* Purchase Transaction */}
              <Route
                path="/AddPurchaseTransaction"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "purchase", "user"]}>
                    <AddPurchaseTransaction />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewPurchaseTransaction"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "purchase", "user"]}>
                    <PurchaseTransactionList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/purchase/edit/:id"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <EditPurchaseTransaction />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/purchase/invoices"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "purchase", "user"]}>
                    <PurchaseInvoiceList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/purchase/invoice/view/:id"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "purchase", "user"]}>
                    <PurchaseInvoiceView />
                  </ProtectedRoute>
                }
              />

              {/* Sales Transaction */}
              <Route
                path="/AddSalesTransaction"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "sales", "user"]}>
                    <AddSalesTransaction />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewSalesTransaction"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "sales", "user"]}>
                    <SalesTransactionList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/sales/edit/:id"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin","user"]}>
                    <EditSalesTransaction />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/sales/invoices"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "sales", "user"]}>
                    <SalesInvoiceList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/sales/invoice/view/:id"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "sales", "user"]}>
                    <SalesInvoiceView />
                  </ProtectedRoute>
                }
              />

              {/* Supplier Payment */}
              <Route
                path="/AddSupplierPayment"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "cashier", "purchase", "user"]}>
                    <AddSupplierPayment />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewSupplierPayment"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "cashier", "purchase", "user"]}>
                    <SupplierPaymentList />
                  </ProtectedRoute>
                }
              />

              {/* Customer Payment */}
              <Route
                path="/AddCustomerPayment"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "cashier", "sales", "user"]}>
                    <AddCustomerPayment />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewCustomerPayment"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "cashier", "sales", "user"]}>
                    <CustomerPaymentList />
                  </ProtectedRoute>
                }
              />

              {/* Transfer */}
              <Route
                path="/AddTransfer"
                element={
                  <ProtectedRoute requiredRole={["admin", "developer", "finance"]}>
                    <Transferform />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewTransfers"
                element={
                  <ProtectedRoute requiredRole={["admin", "developer", "finance"]}>
                    <TransferformList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/transfer/edit/:id"
                element={
                  <ProtectedRoute requiredRole={["admin", "developer"]}>
                    <EditTransferform />
                  </ProtectedRoute>
                }
              />

              {/* Company Routes – ORDER MATTERS */}
              <Route
                path="/AddCompany"
                element={
                  <ProtectedRoute requiredRole={["admin", "developer"]}>
                    <AddCompany />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewCompany"
                element={
                  <ProtectedRoute requiredRole={["admin", "developer"]}>
                    <CompanyList />
                  </ProtectedRoute>
                }
              />

              {/* ========== USER MANAGEMENT ROUTES ========== */}
              {/* User List - requires company admin role */}
              <Route
                path="/company/:companyId/users"
                element={
                  <ProtectedRoute requiredRole={["admin"]}>
                    <CompanyUsersList />
                  </ProtectedRoute>
                }
              />
              {/* Add User - both new and old paths */}
              <Route
                path="/company/:companyId/users/add"
                element={
                  <ProtectedRoute requiredRole={["admin"]}>
                    <AddUserForm />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/company/:companyId/add-user"
                element={
                  <ProtectedRoute requiredRole={["admin"]}>
                    <AddUserForm />
                  </ProtectedRoute>
                }
              />

              {/* Edit Company (must come before general /company/:id) */}
              <Route
                path="/company/edit/:id"
                element={
                  <ProtectedRoute requiredRole={["admin", "developer"]}>
                    <EditCompany />
                  </ProtectedRoute>
                }
              />
              {/* View Company Details */}
              <Route
                path="/company/:id"
                element={
                  <ProtectedRoute requiredRole={["admin", "developer"]}>
                    <ViewCompany />
                  </ProtectedRoute>
                }
              />

              {/* Institution */}
              <Route
                path="/AddInstitution"
                element={
                  <ProtectedRoute requiredRole={["admin", "developer"]}>
                    <AddInstitution />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewInstitution"
                element={
                  <ProtectedRoute requiredRole={["admin", "developer"]}>
                    <InstitutionList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/institution/edit/:id"
                element={
                  <ProtectedRoute requiredRole={["admin", "developer"]}>
                    <EditInstitution />
                  </ProtectedRoute>
                }
              />


              {/* User Registration (system) */}
              <Route
                path="/register"
                element={
                  <ProtectedRoute requiredRole={["admin", "developer"]}>
                    <Register />
                  </ProtectedRoute>
                }
              />
              {/* AuditLogs */}
              <Route
                path="/AuditLogs"
                element={
                  <ProtectedRoute requiredRole={["developer"]}>
                    <AuditLogs />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewAuditLogs"
                element={
                  <ProtectedRoute requiredRole={["developer"]}>
                    <AuditLogsList />
                  </ProtectedRoute>
                }
              />
              {/* Settings */}
              <Route
                path="/settings"
                element={
                  <ProtectedRoute requiredUserType="system" requiredRole={["developer"]}>
                    <Settings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/CompanySettings"
                element={
                  <ProtectedRoute requiredUserType="company" requiredRole="admin">
                    <CompanySettings />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/Subscriptions"
                element={
                  <ProtectedRoute requiredUserType="system" requiredRole={["developer", "admin"]}>
                    <Subscriptions />
                  </ProtectedRoute>
                }
              />

              {/* Customer */}
              <Route
                path="/AddCustomer"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "sales", "user"]}>
                    <AddCustomer />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ViewCustomer"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin", "sales", "user"]}>
                    <CustomerList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/customer/edit/:id"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <EditCustomer />
                  </ProtectedRoute>
                }
              />

              <Route
                path="/MySubscription"
                element={
                  <ProtectedRoute
                    requiredUserType="company"
                    requiredRole={[
                      "admin",
                      "sales",
                      "cashier",
                      "purchase",
                      "user",
                    ]}
                  >
                    <MySubscription />
                  </ProtectedRoute>
                }
              />

              {/* Reports */}
              <Route
                path="/inventorystock"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin","user"]}>
                    <Inventoryvaluation />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/stocksummery"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin","user"]}>
                    <Stocksummery />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/lowstockreport"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin","user"]}>
                    <Lowstockreport />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/purchasereport"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin","user"]}>
                    <Purchasereport />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/salesreport"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin","user"]}>
                    <Salesreport />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/customerreport"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin","user"]}>
                    <Customerreport />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/supplierreport"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin","user"]}>
                    <Supplierreport />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/customerdetailreport"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin","user"]}>
                    <Customerdetailreport />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/supplierdetailreport"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin","user"]}>
                    <Supplierdetailreport />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/dailysummery"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin","user"]}>
                    <Dailysummery />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/expensesummery"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin","user"]}>
                    <Expensesummery />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/trialbalance"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin","user"]}>
                    <TrialBalance />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/balancesheet"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin","user"]}>
                    <BalanceSheet />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/incomestatement"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin","user"]}>
                    <IncomeStatement />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/manual-journal/new"
                element={
                  <ProtectedRoute requiredRole={["developer", "admin"]}>
                    <ManualJournalEntryForm />
                  </ProtectedRoute>
                }
              />

              <Route path="/unauthorized" element={<Unauthorized />} />

              {/* Redirect attempts to login/register when already logged in */}
              <Route path="/login" element={<Navigate to="/" replace />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </div>
        </main>
      </div>
    </CurrencyProvider>
  );
}

// App wrapper
function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
